import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

type CampusType = 'jihang' | 'okjeong' | 'millak';
type BuildingType = '1관' | '2관' | '3관' | '스터디카페';

interface CampusInfo {
  name: string;
  address: string;
  phone: string;
  buildings: {
    [key in BuildingType]: {
      images: string[];
      description: string;
    };
  };
}

const campusData: Record<CampusType, CampusInfo> = {
  jihang: {
    name: '지행캠퍼스',
    address: '경기도 동두천시 지행로 50 성지에스엔비타워 4,5,6층 미래인재학원',
    phone: '010-5647-1320',
    buildings: {
      '1관': {
        images: [
          'https://public.readdy.ai/ai/img_res/085319598b988efb04949e4addfd30af.jpg',
          'https://readdy.ai/api/search-image?query=Korean%20education%20center%20lecture%20room%20whiteboard%20projector%20modern%20furniture%20student%20desks%20bright%20atmosphere%20clean%20interior%20professional%20academy&width=400&height=300&seq=jihang-1-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Academy%20hallway%20corridor%20modern%20design%20bright%20lighting%20clean%20walls%20educational%20institution%20interior%20professional%20atmosphere&width=400&height=300&seq=jihang-1-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20tutoring%20center%20reception%20area%20front%20desk%20modern%20interior%20welcoming%20atmosphere%20professional%20design&width=400&height=300&seq=jihang-1-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Modern%20classroom%20with%20individual%20study%20booths%20partition%20desks%20focused%20learning%20environment%20bright%20lighting&width=400&height=300&seq=jihang-1-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Educational%20center%20waiting%20area%20comfortable%20seating%20modern%20furniture%20bright%20interior%20clean%20design&width=400&height=300&seq=jihang-1-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20academy%20small%20group%20classroom%20round%20table%20discussion%20area%20modern%20interior%20bright%20atmosphere&width=400&height=300&seq=jihang-1-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Modern%20education%20facility%20restroom%20area%20clean%20tiles%20bright%20lighting%20professional%20design&width=400&height=300&seq=jihang-1-8&orientation=landscape',
        ],
        description: '1관은 중등부 전용 학습 공간으로, 최신 멀티미디어 시설과 쾌적한 강의실을 갖추고 있습니다. 개별 학습 부스와 그룹 토론실이 마련되어 있어 다양한 학습 형태를 지원합니다.',
      },
      '2관': {
        images: [
          'https://readdy.ai/api/search-image?query=High%20school%20academy%20classroom%20large%20whiteboard%20modern%20desks%20bright%20interior%20professional%20educational%20environment&width=400&height=300&seq=jihang-2-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20education%20center%20computer%20lab%20modern%20equipment%20student%20workstations%20bright%20lighting&width=400&height=300&seq=jihang-2-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Academy%20science%20laboratory%20modern%20equipment%20educational%20facility%20clean%20design%20professional%20atmosphere&width=400&height=300&seq=jihang-2-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20tutoring%20center%20counseling%20room%20private%20consultation%20area%20comfortable%20seating&width=400&height=300&seq=jihang-2-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Modern%20classroom%20lecture%20hall%20tiered%20seating%20projector%20screen%20educational%20facility&width=400&height=300&seq=jihang-2-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Academy%20break%20room%20student%20lounge%20comfortable%20seating%20vending%20machines%20bright%20interior&width=400&height=300&seq=jihang-2-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20education%20center%20library%20area%20bookshelves%20reading%20tables%20quiet%20study%20space&width=400&height=300&seq=jihang-2-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Modern%20academy%20storage%20lockers%20student%20belongings%20area%20clean%20organized%20design&width=400&height=300&seq=jihang-2-8&orientation=landscape',
        ],
        description: '2관은 고등부 전용 공간으로, 대형 강의실과 컴퓨터실, 과학 실험실을 운영합니다. 입시 상담실과 자료실이 구비되어 체계적인 진학 지도가 가능합니다.',
      },
      '3관': {
        images: [
          'https://readdy.ai/api/search-image?query=Elementary%20school%20academy%20colorful%20classroom%20bright%20cheerful%20interior%20child%20friendly%20furniture%20educational%20toys&width=400&height=300&seq=jihang-3-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20kids%20education%20center%20playful%20learning%20area%20colorful%20design%20safe%20environment&width=400&height=300&seq=jihang-3-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Children%20academy%20art%20room%20creative%20space%20colorful%20supplies%20bright%20interior%20fun%20atmosphere&width=400&height=300&seq=jihang-3-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Elementary%20tutoring%20center%20reading%20corner%20cozy%20seating%20bookshelves%20child%20friendly%20design&width=400&height=300&seq=jihang-3-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20education%20facility%20music%20room%20instruments%20colorful%20interior%20fun%20learning%20environment&width=400&height=300&seq=jihang-3-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20academy%20children%20waiting%20area%20comfortable%20seating%20parent%20consultation%20space&width=400&height=300&seq=jihang-3-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Elementary%20school%20classroom%20small%20desks%20colorful%20chairs%20bright%20windows%20educational%20posters&width=400&height=300&seq=jihang-3-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20academy%20snack%20area%20clean%20tables%20bright%20interior%20child%20safe%20design&width=400&height=300&seq=jihang-3-8&orientation=landscape',
        ],
        description: '3관은 초등부 프리미엄 전용관으로, 아이들의 눈높이에 맞춘 안전하고 쾌적한 학습 환경을 제공합니다. 창의력 개발을 위한 다양한 활동 공간이 마련되어 있습니다.',
      },
      '스터디카페': {
        images: [
          'https://readdy.ai/api/search-image?query=Modern%20study%20cafe%20individual%20cubicles%20desk%20lamps%20quiet%20atmosphere%20focused%20learning%20environment&width=400&height=300&seq=jihang-s-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20study%20room%20private%20booths%20partition%20walls%20comfortable%20chairs%20bright%20lighting&width=400&height=300&seq=jihang-s-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Self%20study%20center%20open%20seating%20area%20large%20tables%20group%20study%20space%20modern%20interior&width=400&height=300&seq=jihang-s-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Study%20cafe%20beverage%20station%20coffee%20machine%20water%20dispenser%20snack%20area%20clean%20design&width=400&height=300&seq=jihang-s-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Modern%20reading%20room%20comfortable%20armchairs%20quiet%20atmosphere%20bookshelves%20ambient%20lighting&width=400&height=300&seq=jihang-s-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Study%20center%20locker%20area%20personal%20storage%20secure%20compartments%20modern%20design&width=400&height=300&seq=jihang-s-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20study%20cafe%20entrance%20reception%20counter%20modern%20interior%20welcoming%20atmosphere&width=400&height=300&seq=jihang-s-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Self%20study%20room%20premium%20booth%20private%20space%20desk%20lamp%20comfortable%20chair%20quiet%20environment&width=400&height=300&seq=jihang-s-8&orientation=landscape',
        ],
        description: '스터디카페는 자기주도 학습을 위한 프리미엄 공간입니다. 개인 부스와 그룹 스터디룸, 음료 코너가 마련되어 있으며, 24시간 냉난방과 보안 시스템을 갖추고 있습니다.',
      },
    },
  },
  okjeong: {
    name: '옥정캠퍼스',
    address: '경기도 양주시 회천남로 92 센타프라자 7,8,9층 미래인재학원',
    phone: '010-5606-1320',
    buildings: {
      '1관': {
        images: [
          'https://readdy.ai/api/search-image?query=Modern%20Korean%20academy%20classroom%20bright%20interior%20wooden%20furniture%20comfortable%20learning%20environment%20professional%20design&width=400&height=300&seq=okjeong-1-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Education%20center%20lecture%20room%20projector%20whiteboard%20student%20desks%20modern%20atmosphere&width=400&height=300&seq=okjeong-1-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Academy%20corridor%20hallway%20modern%20design%20bright%20lighting%20clean%20walls%20professional%20interior&width=400&height=300&seq=okjeong-1-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Korean%20tutoring%20center%20front%20desk%20reception%20area%20welcoming%20atmosphere%20modern%20design&width=400&height=300&seq=okjeong-1-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Individual%20study%20booths%20partition%20desks%20focused%20learning%20bright%20lighting%20modern%20interior&width=400&height=300&seq=okjeong-1-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Education%20facility%20waiting%20lounge%20comfortable%20seating%20modern%20furniture%20bright%20atmosphere&width=400&height=300&seq=okjeong-1-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Small%20group%20classroom%20discussion%20table%20modern%20interior%20bright%20lighting%20professional%20design&width=400&height=300&seq=okjeong-1-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Academy%20facility%20clean%20restroom%20modern%20tiles%20bright%20lighting%20professional%20design&width=400&height=300&seq=okjeong-1-8&orientation=landscape',
        ],
        description: '1관은 중등부 학습 공간으로, 최신 교육 시설과 쾌적한 환경을 제공합니다. 소규모 그룹 수업에 최적화된 강의실이 마련되어 있습니다.',
      },
      '2관': {
        images: [
          'https://readdy.ai/api/search-image?query=High%20school%20classroom%20large%20whiteboard%20modern%20desks%20bright%20interior%20educational%20environment&width=400&height=300&seq=okjeong-2-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Computer%20lab%20modern%20equipment%20workstations%20bright%20lighting%20educational%20facility&width=400&height=300&seq=okjeong-2-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Science%20laboratory%20educational%20equipment%20clean%20design%20professional%20atmosphere&width=400&height=300&seq=okjeong-2-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Counseling%20room%20private%20consultation%20comfortable%20seating%20professional%20interior&width=400&height=300&seq=okjeong-2-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Lecture%20hall%20tiered%20seating%20projector%20screen%20modern%20educational%20facility&width=400&height=300&seq=okjeong-2-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Student%20break%20room%20lounge%20area%20comfortable%20seating%20vending%20machines&width=400&height=300&seq=okjeong-2-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Library%20reading%20area%20bookshelves%20study%20tables%20quiet%20atmosphere&width=400&height=300&seq=okjeong-2-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Student%20lockers%20storage%20area%20organized%20clean%20modern%20design&width=400&height=300&seq=okjeong-2-8&orientation=landscape',
        ],
        description: '2관은 고등부 전용 공간으로, 입시 준비에 필요한 모든 시설을 갖추고 있습니다. 1:1 상담실과 자습실이 운영됩니다.',
      },
      '3관': {
        images: [
          'https://readdy.ai/api/search-image?query=Elementary%20classroom%20colorful%20interior%20child%20friendly%20furniture%20bright%20cheerful%20atmosphere&width=400&height=300&seq=okjeong-3-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20learning%20area%20playful%20design%20colorful%20safe%20environment%20educational%20toys&width=400&height=300&seq=okjeong-3-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Children%20art%20room%20creative%20space%20colorful%20supplies%20fun%20atmosphere&width=400&height=300&seq=okjeong-3-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20reading%20corner%20cozy%20seating%20bookshelves%20child%20friendly%20design&width=400&height=300&seq=okjeong-3-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Children%20activity%20room%20colorful%20interior%20fun%20learning%20environment%20safe%20design&width=400&height=300&seq=okjeong-3-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Parent%20waiting%20area%20comfortable%20seating%20consultation%20space%20bright%20interior&width=400&height=300&seq=okjeong-3-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Elementary%20classroom%20small%20desks%20colorful%20chairs%20educational%20posters%20bright%20windows&width=400&height=300&seq=okjeong-3-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20snack%20area%20clean%20tables%20bright%20interior%20child%20safe%20environment&width=400&height=300&seq=okjeong-3-8&orientation=landscape',
        ],
        description: '3관은 초등부 전용 공간으로, 아이들이 즐겁게 학습할 수 있는 환경을 제공합니다. 안전을 최우선으로 설계되었습니다.',
      },
      '스터디카페': {
        images: [
          'https://readdy.ai/api/search-image?query=Study%20cafe%20individual%20cubicles%20desk%20lamps%20quiet%20focused%20environment%20modern%20design&width=400&height=300&seq=okjeong-s-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Private%20study%20booths%20partition%20walls%20comfortable%20chairs%20bright%20lighting&width=400&height=300&seq=okjeong-s-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Open%20study%20area%20large%20tables%20group%20space%20modern%20interior%20bright%20atmosphere&width=400&height=300&seq=okjeong-s-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Beverage%20station%20coffee%20machine%20water%20dispenser%20snack%20area%20clean%20design&width=400&height=300&seq=okjeong-s-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Reading%20room%20comfortable%20armchairs%20quiet%20atmosphere%20ambient%20lighting%20bookshelves&width=400&height=300&seq=okjeong-s-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Locker%20area%20personal%20storage%20secure%20compartments%20modern%20clean%20design&width=400&height=300&seq=okjeong-s-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Study%20cafe%20entrance%20reception%20modern%20interior%20welcoming%20atmosphere&width=400&height=300&seq=okjeong-s-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Premium%20study%20booth%20private%20space%20desk%20lamp%20comfortable%20quiet%20environment&width=400&height=300&seq=okjeong-s-8&orientation=landscape',
        ],
        description: '스터디카페는 자기주도 학습 공간으로, 개인 부스와 그룹 스터디룸을 운영합니다. 쾌적한 환경에서 집중 학습이 가능합니다.',
      },
    },
  },
  millak: {
    name: '민락캠퍼스',
    address: '경기도 의정부시 오목로 221 골드노블레스 프라자 2,3,4층 미래인재학원',
    phone: '010-5492-1320',
    buildings: {
      '1관': {
        images: [
          'https://readdy.ai/api/search-image?query=Modern%20academy%20classroom%20bright%20interior%20comfortable%20desks%20professional%20learning%20environment&width=400&height=300&seq=millak-1-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Lecture%20room%20projector%20whiteboard%20student%20desks%20modern%20educational%20atmosphere&width=400&height=300&seq=millak-1-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Academy%20hallway%20modern%20design%20bright%20lighting%20clean%20professional%20interior&width=400&height=300&seq=millak-1-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Reception%20desk%20front%20area%20welcoming%20atmosphere%20modern%20design&width=400&height=300&seq=millak-1-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Study%20booths%20individual%20desks%20partition%20focused%20learning%20bright%20lighting&width=400&height=300&seq=millak-1-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Waiting%20lounge%20comfortable%20seating%20modern%20furniture%20bright%20atmosphere&width=400&height=300&seq=millak-1-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Small%20classroom%20discussion%20table%20modern%20interior%20bright%20professional%20design&width=400&height=300&seq=millak-1-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Clean%20restroom%20modern%20tiles%20bright%20lighting%20professional%20facility&width=400&height=300&seq=millak-1-8&orientation=landscape',
        ],
        description: '1관은 중등부 학습 공간으로, 소규모 집중 관리 시스템을 운영합니다. 학생 개개인에게 맞춤형 학습 환경을 제공합니다.',
      },
      '2관': {
        images: [
          'https://readdy.ai/api/search-image?query=High%20school%20classroom%20whiteboard%20modern%20desks%20bright%20educational%20interior&width=400&height=300&seq=millak-2-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Computer%20room%20modern%20equipment%20workstations%20bright%20educational%20facility&width=400&height=300&seq=millak-2-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Science%20lab%20educational%20equipment%20clean%20professional%20atmosphere&width=400&height=300&seq=millak-2-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Private%20consultation%20room%20comfortable%20seating%20professional%20interior&width=400&height=300&seq=millak-2-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Large%20lecture%20room%20projector%20modern%20educational%20facility&width=400&height=300&seq=millak-2-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Break%20room%20lounge%20comfortable%20seating%20vending%20machines%20bright&width=400&height=300&seq=millak-2-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Library%20area%20bookshelves%20reading%20tables%20quiet%20study%20atmosphere&width=400&height=300&seq=millak-2-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Student%20lockers%20organized%20storage%20clean%20modern%20design&width=400&height=300&seq=millak-2-8&orientation=landscape',
        ],
        description: '2관은 고등부 전용 공간으로, 입시 전문 상담과 체계적인 학습 관리를 제공합니다. 자습실과 상담실이 완비되어 있습니다.',
      },
      '3관': {
        images: [
          'https://readdy.ai/api/search-image?query=Elementary%20classroom%20colorful%20child%20friendly%20furniture%20bright%20cheerful%20interior&width=400&height=300&seq=millak-3-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20learning%20space%20playful%20colorful%20safe%20educational%20environment&width=400&height=300&seq=millak-3-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Children%20art%20room%20creative%20colorful%20supplies%20fun%20atmosphere&width=400&height=300&seq=millak-3-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20reading%20area%20cozy%20bookshelves%20child%20friendly%20design&width=400&height=300&seq=millak-3-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Activity%20room%20colorful%20fun%20learning%20safe%20environment&width=400&height=300&seq=millak-3-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Parent%20waiting%20consultation%20comfortable%20seating%20bright%20interior&width=400&height=300&seq=millak-3-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Elementary%20desks%20colorful%20chairs%20educational%20posters%20bright%20classroom&width=400&height=300&seq=millak-3-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Kids%20snack%20clean%20tables%20bright%20child%20safe%20area&width=400&height=300&seq=millak-3-8&orientation=landscape',
        ],
        description: '3관은 초등부 전용 공간으로, 아이들의 안전과 즐거운 학습을 최우선으로 합니다. 창의력 개발 프로그램을 운영합니다.',
      },
      '스터디카페': {
        images: [
          'https://readdy.ai/api/search-image?query=Study%20cafe%20cubicles%20desk%20lamps%20quiet%20focused%20modern%20environment&width=400&height=300&seq=millak-s-1&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Private%20booths%20partition%20comfortable%20chairs%20bright%20lighting%20study&width=400&height=300&seq=millak-s-2&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Open%20study%20tables%20group%20space%20modern%20bright%20atmosphere&width=400&height=300&seq=millak-s-3&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Coffee%20station%20beverage%20dispenser%20snack%20area%20clean%20modern&width=400&height=300&seq=millak-s-4&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Reading%20lounge%20armchairs%20quiet%20ambient%20lighting%20bookshelves&width=400&height=300&seq=millak-s-5&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Lockers%20personal%20storage%20secure%20modern%20clean%20design&width=400&height=300&seq=millak-s-6&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Study%20cafe%20reception%20entrance%20modern%20welcoming%20atmosphere&width=400&height=300&seq=millak-s-7&orientation=landscape',
          'https://readdy.ai/api/search-image?query=Premium%20booth%20private%20desk%20lamp%20comfortable%20quiet%20study&width=400&height=300&seq=millak-s-8&orientation=landscape',
        ],
        description: '스터디카페는 자기주도 학습을 위한 공간입니다. 개인 부스와 그룹룸, 음료 코너가 마련되어 있어 편안한 학습이 가능합니다.',
      },
    },
  },
};

const buildings: BuildingType[] = ['1관', '2관', '3관', '스터디카페'];

export default function CampusPage() {
  const [selectedCampus, setSelectedCampus] = useState<CampusType>('jihang');
  const [selectedBuilding, setSelectedBuilding] = useState<BuildingType>('1관');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 캠퍼스 - 민락·옥정·지행';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '미래인재학원 캠퍼스 위치와 시설을 확인하세요. 지행캠퍼스, 옥정캠퍼스, 민락캠퍼스 각 지점의 상세 정보를 제공합니다.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 캠퍼스 안내 - 민락, 옥정, 지행 학원 위치');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '미래인재학원 캠퍼스 위치와 시설을 확인하세요. 지행캠퍼스, 옥정캠퍼스, 민락캠퍼스 각 지점의 상세 정보를 제공합니다.');
    }
  }, []);

  const currentCampus = campusData[selectedCampus];
  const currentBuilding = currentCampus.buildings[selectedBuilding];

  const handleCampusSelect = (campus: CampusType) => {
    setSelectedCampus(campus);
    setSelectedBuilding('1관');
    setIsDropdownOpen(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation currentPage="campus" />
      
      {/* Hero Section */}
      <section className="pt-20 relative min-h-[400px] flex items-center">
        <div className="absolute inset-0 bg-black">
          <img 
            src="https://readdy.ai/api/search-image?query=Modern%20Korean%20education%20academy%20building%20exterior%20elegant%20architecture%20professional%20educational%20institution%20contemporary%20design%20clean%20lines%20glass%20windows%20urban%20setting%20daytime%20bright%20atmosphere%20high%20quality%20architectural%20photography&width=1920&height=500&seq=campus-hero-new&orientation=landscape"
            alt="Campus Hero"
            className="w-full h-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
          <div className="max-w-2xl">
            <span className="text-amber-400 font-semibold text-sm tracking-wider uppercase">Campus Guide</span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
              미래인재학원 캠퍼스 안내
            </h1>
            <p className="text-lg text-gray-300 leading-relaxed">
              미래인재학원의 최고의 교육 환경을 직접 확인해보세요
            </p>
          </div>
        </div>
      </section>

      {/* Campus Selector Dropdown */}
      <section className="py-6 px-4 bg-gray-50 border-b border-gray-200 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4">
            <span className="text-gray-700 font-semibold text-sm">캠퍼스 선택</span>
            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center gap-3 bg-white border border-gray-300 rounded-xl px-5 py-3 min-w-[200px] hover:border-amber-500 transition-all cursor-pointer shadow-sm"
              >
                <div className="w-8 h-8 bg-amber-500 rounded-lg flex items-center justify-center">
                  <i className="ri-building-line text-black text-lg"></i>
                </div>
                <span className="font-semibold text-gray-900">{currentCampus.name}</span>
                <i className={`ri-arrow-down-s-line text-gray-500 text-xl ml-auto transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden z-50">
                  {(Object.keys(campusData) as CampusType[]).map((campus) => (
                    <button
                      key={campus}
                      onClick={() => handleCampusSelect(campus)}
                      className={`w-full flex items-center gap-3 px-5 py-4 hover:bg-amber-50 transition-colors cursor-pointer ${
                        selectedCampus === campus ? 'bg-amber-50 border-l-4 border-amber-500' : ''
                      }`}
                    >
                      <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        selectedCampus === campus ? 'bg-amber-500' : 'bg-gray-200'
                      }`}>
                        <i className={`ri-building-line text-lg ${
                          selectedCampus === campus ? 'text-black' : 'text-gray-600'
                        }`}></i>
                      </div>
                      <span className={`font-medium ${
                        selectedCampus === campus ? 'text-amber-700' : 'text-gray-700'
                      }`}>
                        {campusData[campus].name}
                      </span>
                      {selectedCampus === campus && (
                        <i className="ri-check-line text-amber-500 ml-auto"></i>
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Campus Info Section */}
      <section className="py-12 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          {/* Address and Phone */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 mb-10">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-xl mb-2">{currentCampus.name}</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">{currentCampus.address}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center">
                  <i className="ri-phone-line text-2xl text-amber-500"></i>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">대표번호</p>
                  <a href={`tel:${currentCampus.phone}`} className="text-white font-bold text-xl hover:text-amber-400 transition-colors cursor-pointer">
                    {currentCampus.phone}
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Building Tabs */}
          <div className="flex flex-wrap gap-2 mb-8">
            {buildings.map((building) => (
              <button
                key={building}
                onClick={() => setSelectedBuilding(building)}
                className={`px-6 py-3 rounded-xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                  selectedBuilding === building
                    ? 'bg-amber-500 text-black shadow-lg shadow-amber-500/30'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {building}
              </button>
            ))}
          </div>

          {/* Photo Gallery */}
          <div className="mb-8">
            <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
              <i className="ri-image-line text-amber-500"></i>
              {selectedBuilding} 시설 사진
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {currentBuilding.images.map((image, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedImage(image)}
                  className="aspect-[4/3] rounded-xl overflow-hidden cursor-pointer group relative"
                >
                  <img
                    src={image}
                    alt={`${currentCampus.name} ${selectedBuilding} 사진 ${index + 1}`}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <i className="ri-zoom-in-line text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Description */}
          <div className="bg-gray-50 rounded-2xl p-8">
            <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-information-line text-amber-500"></i>
              {selectedBuilding} 소개
            </h4>
            <p className="text-gray-600 leading-relaxed">
              {currentBuilding.description}
            </p>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>
          <img
            src={selectedImage}
            alt="확대 이미지"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
}
